import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { AWS_ATHENA } from "../../Constants"

function ZdqAwsAthenaConnectorStatus() {
    return <ZdqConnectorStatus vendor={AWS_ATHENA}></ZdqConnectorStatus>
}

export default ZdqAwsAthenaConnectorStatus